/** #@condition: virtuals **/
/** Only if virtuals feature is enabled **/
import MojitoPresentation from 'mojito/presentation';

import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {virtualsFactory} from './virtuals.factory';

import SCHEMA from './virtuals.schema.yaml';
import PALETTE_SCHEMA from './virtuals.palette-schema.yaml';

const NavigationPathBuilder = MojitoPresentation.Base.Navigation.NavigationPathBuilder;

class VirtualsFeature extends AbstractVisualFeature {
    get name() {
        return 'Virtuals';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get ready() {
        return this.config.enabled;
    }

    get intent() {
        return {
            type: MojitoPresentation.Base.Intent.Types.VIEW,
            data: NavigationPathBuilder.toVirtualSports(),
        };
    }

    getSerializableVisualConfig(PALETTE) {
        const viewsConfig = virtualsFactory(PALETTE);
        const sportIdMap = GENBET_BASED ? this.config.sportIdMapGenbet : this.config.sportIdMapQuantum;

        mergeTo(viewsConfig, {
            SportsMenuView: {
                showVirtuals: this.config.showInSportsMenu,
            },
            VirtualEventsCoupon: {
                streamingSportIdMap: sportIdMap,
                streamingChannelIdMap: this.config.streamingChannelIdMap,
            },
        });

        if (GENBET_BASED) {
            mergeTo(viewsConfig, {
                VirtualEventsCoupon: {
                    streamView: {
                        iframeViewer: {
                            urlConfig: this.config.wide,
                        },
                        compactIframeViewer: {
                            urlConfig: this.config.compact,
                        },
                        withChannelIframeViewer: {
                            urlConfig: this.config.withChannelWide,
                        },
                        withChannelCompactIframeViewer: {
                            urlConfig: this.config.withChannelCompact,
                        },
                    },
                    inplayStreamView: {
                        iframeViewer: {
                            urlConfig: this.config.wideInplay || {},
                        },
                        compactIframeViewer: {
                            urlConfig: this.config.compactInplay || {},
                        },
                        channelIframeViewer: {
                            urlConfig: this.config.channelWide || {},
                        },
                        compactChannelIframeViewer: {
                            urlConfig: this.config.channelCompact || {},
                        },
                    },
                },
            });
        } else {
            mergeTo(viewsConfig, {
                VirtualStream: {
                    iframeViewer: {
                        urlConfig: this.config.wide,
                    },
                    compactIframeViewer: {
                        urlConfig: this.config.compact,
                    },
                },
            });
        }

        return viewsConfig;
    }
}

if (FEATURES.virtuals) {
    new VirtualsFeature(SportsContent);
}
